module.exports = __webpack_public_path__ + "static/img/about_cn.8407206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about_cn.png
// module id = b1Vu
// module chunks = 1